import { ApiError } from '@invite/app-core';

/** `/owner/*` answers 403 when Invite Owner is off for the team. */
export const isNotEnabled = (error: unknown): boolean =>
  error instanceof ApiError && error.status === 403;
